import { TFunction } from 'i18next';
import { z } from 'zod';

import {
  areEmailDomainsValid,
  formatEmailDomains,
} from '@bvi/api-interfaces/email-domain';

export const buildValidationSchema = (t: TFunction) => {
  const validationFields = {
    name: z.string().min(1, t('error.form.required')).max(128).default(''),
    contactPerson: z.string().min(1, t('error.form.required')).default(''),
    contactEmail: z
      .string()
      .min(1, t('error.form.required'))
      .email(t('error.form.email'))
      .default(''),
    companySizeId: z.number({
      invalid_type_error: t('error.form.required'),
      required_error: t('error.form.required'),
    }),
    emailDomain: z
      .string()
      .min(1, t('error.form.required'))
      .transform((value) => formatEmailDomains(value))
      .refine((value) => areEmailDomainsValid(value), {
        message: t('error.form.emailDomain'),
      }),
    signatoryName: z.string().optional().nullable(),
    signatoryEmail: z
      .string()
      .email(t('error.form.email'))
      .or(z.literal(''))
      .optional()
      .nullable(),
    billingContactName: z.string().optional().nullable(),
    billingContactEmail: z
      .string()
      .email(t('error.form.email'))
      .or(z.literal(''))
      .optional()
      .nullable(),
  };

  return z.object(validationFields);
};
